<!--
 - Author : wanghongling.
 - Date   : 2020/11/24.
 - File   : horizontalBar.横向柱状图
 -->

<template>
  <div :id="id" :style="{width: horizontalObj.width, height: horizontalObj.height}">
  </div>
</template>

<script>
  export default {
    name: 'my-horizontal',
    data() {
      return {
        myHorizontal: null
      }
    },
    props: {
      id: {
        type: String,
        default: 'test'
      },
      horizontalObj: {
        default: () => {
          return {
            width: '300px',
            height: '190px',
            nameList: ['18岁以下', '18-24岁', '25-34岁', '35-44岁', '45-54岁', '55-64岁', '65岁以上'],
            data: [2, 12, 20, 19, 17, 13, 8],
            barWidth: 15
          }
        },
        type: Object
      }
    },
    watch: {
      barList: {
        handler() {
          this.$nextTick(() => {
            window.removeEventListener('resize', this.resizeEvent)
            this.makeBar()
          })
        },
        deep: true
      }
    },
    destroyed() {
      this.$echarts.dispose(this.myHorizontal)
      window.removeEventListener('resize', this.resizeEvent)
      this.myHorizontal = null
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        this.myHorizontal = this.$echarts.init(document.getElementById(this.id))
        this.makeHorizontal()
      },
      calMax(arr) {
        let max = 0
        arr.forEach(el => {
          el.forEach(el1 => {
            if (!(el1 === undefined || el1 === '')) {
              if (max < el1) {
                max = el1;
              }
            }
          })
        })
        let maxint = Math.ceil(max / 9.5)
        //不让最高的值超过最上面的刻度
        let maxval = maxint * 10
        //让显示的刻度是整数
        return maxval
      },
      makeHorizontal() {
        let getmydmc = this.horizontalObj.nameList //数据点名称
        let getmyd = this.horizontalObj.data
        let sum = 0
        for (let i = 0; i < getmyd.length; i++) {
          sum = sum + getmyd[i]
        }
        // const getmydzd = new Array(getmyd.length).fill(sum)
        let max = Math.ceil(this.calMax([getmyd]) / 10) * 10
        let option = {
          grid: {
            left: '75',
            right: '45',
            bottom: '0',
            top: '15'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'none'
            },
            formatter: function(params) {
              return params[0].name + ': ' + params[0].value + '人'
            }
          },
          xAxis: [{
            type: 'value',
            axisLabel: {
              margin: 5,
              color: 'rgba(0,0,0,0)',
              textStyle: {
                fontSize: '13'
              }
            },
            min: 0,
            // max: max, // 计算最大值
            // interval: max / 5, //  平均分为5份
            splitNumber: 5,
            splitLine: {
              show: false,
              lineStyle: {
                color: '#D8D8D8'
              }
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            }
          }, {
            type: 'value',
            axisLabel: {
              show: false
            },
            min: 0,
            max: max, // 计算最大值
            interval: max / 10, //  平均分为5份
            splitNumber: 10,
            splitLine: {
              show: false,
              lineStyle: {
                type: 'dashed',
                color: '#D8D8D8'
              }
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            }
          }],
          yAxis: [{
            type: 'category',
            inverse: true,
            axisLabel: {
              textStyle: {
                color: '#0aaade',
                fontSize: '15'
              }
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#0c4a75'
              }
            },
            data: getmydmc
          }, {
            type: 'category',
            inverse: true,
            axisLabel: {
              textStyle: {
                color: '#0aaade',
                fontSize: '14'
              },
              formatter: function(value) {
                let finalData = sum === 0 ? 0 : Math.floor((value / sum) * 100)
                return finalData + '%'
              }
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#0c4a75'
              }
            },
            data: getmyd
          }],
          series: [{
            name: '值',
            type: 'bar',
            zlevel: 1,
            xAxisIndex: 0,
            itemStyle: {
              normal: {
                // barBorderRadius: [0, 5, 5, 0],
                color: '#009cff'
              }
            },
            barWidth: this.horizontalObj.barWidth,
            data: getmyd,
            animationDuration: 2000,
            animationDurationUpdate: 400,
            animationEasing: 'cubicIn',
            animationDelay: function (idx) {
              return idx * 280 + 100
            }
          }
          // {
          //   name: '背景',
          //   type: 'bar',
          //   barWidth: 15,
          //   barGap: '-100%',
          //   xAxisIndex: 1,
          //   data: getmydzd,
          //   itemStyle: {
          //     normal: {
          //       color: '#021625',
          //       barBorderRadius: [0, 5, 5, 0],
          //     }
          //   },
          // }
          ]
        }
        this.myHorizontal.setOption(option)
        window.addEventListener('resize', this.resizeEvent)
      },
      /**
       * echart图表适应
       * @author: whl
       * @createDate: 2019/8/9
       * @return {Object}
       */
      resizeEvent () {
        this.myHorizontal.resize() // 使图表适应
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/echarts/horizontalBar.vue